// src/layouts/about/index.jsx

import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import Footer from "examples/Footer";
import VuiButton from "components/VuiButton";

function AboutPage() {
  const isSmallScreen = useMediaQuery("(max-width:389px)");
  const theme = useTheme();

  return (
    <DashboardLayout>
      <DefaultNavbar /> {/* <DashboardNavbar /> */}
      <VuiBox py={3} px={isSmallScreen ? 1 : 5} display="flex" justifyContent="center">
        <Card sx={{ maxWidth: "960px", width: "100%" }}>
          <CardContent>
            {/* Títulos centralizados */}
            <VuiBox textAlign="center" mb={4}>
              <VuiTypography variant="button" color="success" fontWeight="bold" mb={1}>
                Conheça minha história
              </VuiTypography>
              <VuiTypography variant="h2" color="white" fontWeight="bold">
                Alexandre Fichtler — Designer & Desenvolvedor
              </VuiTypography>
            </VuiBox>

            {/* Grid com imagem à esquerda e texto à direita */}
            <Grid container spacing={4} alignItems="flex-start">
              {/* Imagem - lado esquerdo */}
              <Grid item xs={12} md={5}>
                <VuiBox
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="flex-start" // ← garante alinhamento no topo
                  position="relative"
                  sx={{ minHeight: "360px" }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/perfil/perfil-alexandre.webp`}
                    alt="Perfil Alexandre"
                    style={{
                      width: "100%",
                      maxWidth: "270px",
                      borderRadius: "24px",
                      objectFit: "cover",
                      zIndex: 1,
                    }}
                  />

                  {/* Luz difusa atrás da imagem */}
                  <VuiBox
                    sx={{
                      position: "absolute",
                      top: 0, // ← reposicionado para acompanhar o topo da imagem
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "360px",
                      height: "360px",
                      borderRadius: "50%",
                      background:
                        "radial-gradient(circle, rgba(165, 228, 69, 0.3) 0%, rgba(165, 228, 69, 0) 80%)",
                      filter: "blur(40px)",
                      zIndex: 0,
                      pointerEvents: "none",
                    }}
                  />
                </VuiBox>
              </Grid>

              {/* Texto - lado direito */}
              <Grid item xs={12} md={7}>
                <VuiTypography variant="body2" color="text" mb={3}>
                  Meu objetivo é criar pontes entre ideias, pessoas e tecnologias. Cada projeto que
                  desenvolvo nasce de uma escuta atenta, de uma conexão genuína com quem está do outro lado.
                  Mais do que entregar produtos visuais ou funcionais, eu proponho soluções com significado,
                  que conectam inovação e estratégia.
                  <br />
                  <br />
                  Sou formado em Jornalismo, com mais de 30 anos de experiência como editor de arte, atuando
                  com design gráfico editorial e publicitário. Ao longo dos anos, desenvolvi materiais para
                  revistas, jornais, anúncios, folders e publicações institucionais.
                  <br />
                  <br />
                  Atualmente, foco em soluções digitais integradas em UX, UI e desenvolvimento frontend/backend, com projetos personalizados em React, Tailwind, Laravel, PHP, Python, micro SaaS, APIs e integrações com IA. Desenvolvo automações inteligentes por meio de abordagens tradicionais ou low code para fluxos automatizados, utilizando frameworks modernos e estratégias de marketing digital.
                  <br />
                  <br />
                  Tem um projeto em mente? Me chame no WhatsApp — vai ser um prazer conversar com você.
                </VuiTypography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </VuiBox>

      <Footer />
    </DashboardLayout>
  );
}

export default AboutPage;